@import '~style-sheet-helpers/core.less';
@import '../constants/spacing.module.less';
@import '../app-brand/entities/entity-layer.module.less';

@input-states: {
  &:active,
  &:active:hover {
    border: 1px solid var(--left-nav--advanced-search-form--active-border-color);
    box-shadow: 0 0 0 1px var(--left-nav--advanced-search-form--active-shadow-color);
  }

  &:hover {
    background: var(--left-nav--advanced-search-form--input-hover-background-color);
    border: 1px solid var(--left-nav--advanced-search-form--active-border-color);
  }
};

@input-text: {
  color: var(--left-nav--advanced-search-filter--text-color);
  font-size: 14px;
};

.advanced-search-base {
  background: transparent;
  padding: @space-8 @space-16;
  width: 239px;
}

.button-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0;

  svg {
    width: 12px;
    margin-right: 8px;
  }
}

.reset-button {
  margin-right: 10px;
}

.filterInput {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.filterLabel {
  color: var(--left-nav--advanced-search-filter--label-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}

.more-criteria {
  align-items: center;
  color: var(--left-nav--advanced-search-filter--text-color);
  display: flex;
  font-size: 12px;
  justify-content: center;
  margin-bottom: 10px;
  padding: 5px;
  width: 100%;

  a {
    color: var(--left-nav--advanced-search-filter--text-color);
    text-decoration: underline;

    &:focus {
      background: none;
    }
  }

  svg {
    background-color: transparent;
    border-radius: 50%;
    fill: var(--left--nav-advanced-search-filter--more-criteria-icon-color);
    height: 12px;
    margin: 0 6px 0 2px;
    width: 12px;
  }
}

.reset-icon {
  transform: rotate(90deg);
}

.exit-advanced-search-text {
  color: var(--left-nav--advanced-search-filter--toggle-color);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 24px 5px 8px;
  margin-left: 11px;

  .advanced-search-exit-arrow {
    fill: var(--left-nav--advanced-search-filter--toggle-color);
    margin-right: 8px;
    width: 16px;
  }
}

.advanced-search-text {
  color: var(--left-nav--advanced-search-filter--toggle-color);
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  padding: 4px 16px 8px;
}

.advanced-search-button {
  width: 100%;
  display: flex;
  align-items: center;
  :focus {
    background: transparent;
  }
}
